var map = {
	"./2013.json": [
		751,
		751
	],
	"./2014.json": [
		605,
		986
	],
	"./2015.json": [
		693,
		693
	],
	"./2016.json": [
		648,
		648
	],
	"./2017.json": [
		291,
		291
	],
	"./2018.json": [
		646,
		646
	],
	"./2019.json": [
		641,
		641
	],
	"./2021.json": [
		466,
		466
	],
	"./2022.json": [
		520,
		139
	],
	"./2023.json": [
		728,
		728
	],
	"./2024-borak.json": [
		159,
		159
	],
	"./2024.json": [
		937,
		937
	],
	"./2025.json": [
		254,
		254
	],
	"./2026.json": [
		943,
		943
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 899;
module.exports = webpackAsyncContext;